<script>
import base from './base.vue';
export default {
    extends:base,
    data(){
        return{
            title:'采购单',
        }
    },
    methods:{
        checkend(obj){
            if(this.editMode==1){
                obj.id = this.orderid;
                this.$api.mEditOrder(obj).then(res=>{
                    if(res.data.code==1){
                        this.$notify({
                            title: "编辑采购",
                            message: "编辑成功",
                            type: "success",
                            duration: 1000,
                        });
                        this.$router.push('/purchase');
                    }else{
                        this.$common.error('编辑失败');
                        this.lock = false;
                    }
                })
            }else{
                this.$api.createOrder(obj).then(res=>{
                    if(res.data.code==1){
                        this.$notify({
                            title: "新增采购",
                            message: "新增成功",
                            type: "success",
                            duration: 1000,
                        });
                        this.$router.push('/purchase');
                    }else{
                        this.$common.error('新增失败');
                        this.lock = false;
                    }
                })
            }
            
        }
    }
}
</script>